// extracted by mini-css-extract-plugin
export default {"body":"house-account-assignment-modal_body__a7r6n","searchRow":"house-account-assignment-modal_searchRow__-LRLj","error":"house-account-assignment-modal_error__vitWt"};